/** 이미지 선택·압축 공통 제한 (QuickImageUpload, storage, 각종 write 폼) */

export const IMAGE_INPUT_ACCEPT = 'image/jpeg,image/png,image/gif,image/webp';

export const MAX_ORIGINAL_IMAGE_BYTES = 10 * 1024 * 1024;
export const MAX_COMPRESSED_IMAGE_BYTES = 5 * 1024 * 1024;

export const IMAGE_PICK_TOAST = {
  tooLargeOriginal: '사진 용량이 너무 큽니다 (최대 10MB)',
  invalidType: 'JPG, PNG, GIF, WEBP만 가능합니다',
  tooLargeCompressed: '압축 후에도 용량이 큽니다. 더 작은 이미지를 사용해주세요',
};

const ALLOWED_MIME = new Set(['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp']);
const EXT_OK = /\.(jpe?g|png|gif|webp)$/i;

export class ImagePickValidationError extends Error {
  /** @param {string} toastMessage */
  constructor(toastMessage) {
    super(toastMessage);
    this.name = 'ImagePickValidationError';
    this.toastMessage = toastMessage;
  }
}

/** @param {File} file */
export function isAllowedImageMime(file) {
  if (!file) return false;
  const t = String(file.type || '').toLowerCase();
  if (ALLOWED_MIME.has(t)) return true;
  return EXT_OK.test(String(file.name || ''));
}

/** @param {File} file @returns {{ ok: true } | { ok: false, toast: string }} */
export function validateOriginalImageFile(file) {
  if (!file) return { ok: false, toast: IMAGE_PICK_TOAST.invalidType };
  if (!isAllowedImageMime(file)) return { ok: false, toast: IMAGE_PICK_TOAST.invalidType };
  if (file.size > MAX_ORIGINAL_IMAGE_BYTES) return { ok: false, toast: IMAGE_PICK_TOAST.tooLargeOriginal };
  return { ok: true };
}

/** @param {File|Blob} file @returns {{ ok: true } | { ok: false, toast: string }} */
export function validateCompressedImageFile(file) {
  if (!file) return { ok: false, toast: IMAGE_PICK_TOAST.tooLargeCompressed };
  if (file.size > MAX_COMPRESSED_IMAGE_BYTES) {
    return { ok: false, toast: IMAGE_PICK_TOAST.tooLargeCompressed };
  }
  return { ok: true };
}

/** @param {number} bytes */
export function formatImageSize(bytes) {
  const n = Number(bytes) || 0;
  if (n < 1024) return `${n}B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)}KB`;
  return `${(n / (1024 * 1024)).toFixed(1)}MB`;
}

/** @param {number} originalBytes @param {number} compressedBytes */
export function formatImageSizePair(originalBytes, compressedBytes) {
  return `원본 ${formatImageSize(originalBytes)} → 압축 후 ${formatImageSize(compressedBytes)}`;
}

/** @param {unknown} err @param {(msg: string, opts?: { type?: string }) => void} [showToast] @returns {boolean} */
export function notifyImagePickError(err, showToast) {
  if (err instanceof ImagePickValidationError && showToast) {
    showToast(err.toastMessage, { type: 'error' });
    return true;
  }
  return err instanceof ImagePickValidationError;
}
